import React, { Component, createRef, useState } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { v4 as uuidv4 } from 'uuid';

import ImportFileConfirmOverlayDialog from '../../dialogs/importFileConfirmOverlayDialog';
import { routes } from '../../../redux/api/routes';
import PartsNetInstallForm from './partsNetInstallForm';
import 'react-datepicker/dist/react-datepicker.css';
import AccountNumberAutoSuggests from '../common/accountNumberAutoSuggestsAvailPricing';
import { DATE_TIME_FORMAT } from '../../common/messageConstants';
import {
	updateCartOrderPoints,
	saveCreateOrderPayload,
	saveAvailabilityOnChangeAddress,
	saveToCart,
	getProductsFromS3,
	saveAvailabilityPricingOfImportedFile,
	getOnlinePricingForParts,
	addToPartsCart,
	ajaxRequestInitiated,
	ajaxRequestCompleted,
	savePricesToCart
} from '../../../redux/actions';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import ProductsInTheCartOverlayDialog from '../../dialogs/productsInTheCartOverlayDialog';
import {
	INTERNATIONAL_ZIP_CODE,
	MODIFIERS_EXCLUDED_FROM_VOLUME_DISCOUNT,
	PNET_APP_QUERY_PARAM,
	PNET_GOP_BATCH_SIZE,
	shippingMethods
} from '../../common/partsNetConstants';
import QuantityInput from '../common/quantityInput';
import CollapsibleSection from '../../common/collapsibleSection';
import useDebounce from '../../../hooks/useDebounce';
import useUpdateEffect from '../../../hooks/useUpdateEffect';

const { s3BucketAPIBaseURL } = routes;

const getInitialItems = agreementNumber =>
	[...Array(6)].map(() => ({
		id: uuidv4(),
		itemNumber: '',
		requestedQuantity: '',
		itemDetails: null,
		agreementNumber,
		requestedQuantityError: false,
		agreementNumberError: false,
		customerReference: '',
		customerReferenceError: false
	}));

const CustomerReferenceInput = ({ value, onChange }) => {
	const [customerReference, setCustomerReference] = useState(value.toUpperCase());
	const debouncedCustomerReference = useDebounce(customerReference);

	useUpdateEffect(() => {
		onChange(debouncedCustomerReference);
	}, [debouncedCustomerReference]);

	const handleChange = event => {
		setCustomerReference(event.target.value.toUpperCase());
	};

	return <input type="text" className="short" value={customerReference} onChange={handleChange} />;
};

class PartsNetQuickOrderForm extends Component {
	constructor(props) {
		super(props);

		const agreementNumber = props.state.user.selectedPriceSource.AGREEMENT_NUMBER;

		const orderInfo = {
			showFreightForwarder: 'N',
			freightForwarder: '',
			isFreightForwarderError: false,
			availableFreightForwarders: null,
			orderType: 'R',
			shippingMethod: shippingMethods[props.isInternationalPartsCustomer ? 'international' : 'domestic'].regular[0].displayName,
			requestedShipDate: moment(),
			shipSet: ''
		};

		this.state = {
			partsNetSalesAgreements: [],
			pimDataByItem: [],
			items: getInitialItems(agreementNumber),
			backupItems: [],
			orderWeight: 0.0,
			pointValue: 0.0,
			fileName: '',
			fileUploadStatus: null,
			availabilityData: [],
			pimData: [],
			pricingData: [],
			finalItems: [],
			isManualAvailabilityCheckRequired: false,
			...orderInfo
		};
		this.installFormRef = createRef();
		this.setChangeMethod = [];
	}

	componentDidMount() {
		// this.setState({
		// 	partsNetSalesAgreements: this.props.state.user.selectedAccountsAllPriceSources.responseObject.filter(priceSource => priceSource.AGREEMENT_TYPE === 'GEA Parts')
		// });

		//we are using single sales agreement for now
		this.setState({
			partsNetSalesAgreements: [this.props.state.user.selectedPriceSource]
		});
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.state.user && nextProps.state.user.selectedAddress) {
			if ((this.props.state.user && this.props.state.user.selectedAddress) !== nextProps.state.user.selectedAddress) {
				const selectedAddress = JSON.parse(nextProps.state.user.selectedAddress || '{}');
				this.refreshAvailability({
					isItemOrderabilityRequired: true,
					zipCode: selectedAddress.COUNTRY === 'US' ? selectedAddress.POSTALCODE && selectedAddress.POSTALCODE.split('-')[0] : INTERNATIONAL_ZIP_CODE
				});
			}
		}

		if (nextProps.isInternationalPartsCustomer !== this.props.isInternationalPartsCustomer) {
			this.setState({
				shippingMethod:
					shippingMethods[nextProps.isInternationalPartsCustomer ? 'international' : 'domestic'][this.state.orderType === 'R' ? 'regular' : 'emergency'][0].displayName
			});
		}
	}

	componentWillUnmount() {
		this.props.saveAvailabilityPricingOfImportedFile(null);
		this.props.saveAvailabilityOnChangeAddress(null);
	}

	handleRequestedShipDateChange = date => {
		this.setState({ requestedShipDate: date }, () => {
			this.refreshAvailability();
		});
	};

	handleChange = event => {
		const { name, value } = event.target;

		const newState = {
			[name]: value
		};

		if (name === 'orderType') {
			newState.shippingMethod =
				shippingMethods[this.props.isInternationalPartsCustomer ? 'international' : 'domestic'][value === 'R' ? 'regular' : 'emergency'][0].displayName;
		} else if (name === 'showFreightForwarder') {
			if (value === 'N') {
				newState.freightForwarder = '';
				newState.isFreightForwarderError = false;
			}
		} else if (name === 'freightForwarder') {
			newState.isFreightForwarderError = false;
		}

		this.setState(
			{
				...newState
			},
			() => {
				if (name === 'shipSet') {
					this.refreshAvailability();
				} else if (name === 'showFreightForwarder' && value === 'Y') {
					if (!(this.props.state.order.createOrderPayload && this.props.state.order.createOrderPayload.availableFreightForwarders)) {
						this.props.fetchFreightForwarders(availableFreightForwarders => {
							this.props.saveCreateOrderPayload({ ...(this.props.state.order.createOrderPayload || {}), availableFreightForwarders });
						});
					}
				}
			}
		);
	};

	getAddressParamsForOrderability = () => {
		const selectedAddress = JSON.parse(this.props.state.user.selectedAddress || '{}');
		const shipToOrgId = selectedAddress.SITE_USE_ID;
		return `shipToOrgId=${shipToOrgId}`;
	};

	updateQuickOrderState = (itemIndex, itemDetails) => {
		const items = this.state.items;
		const itemToUpdate = items[itemIndex];

		if (Array.isArray(itemDetails)) {
			if (itemDetails.length) {
				const availabilityPricingOfImportedFile = JSON.parse(JSON.stringify(this.props.state.order.availabilityPricingOfImportedFile)) || [];

				itemDetails.forEach(item => {
					availabilityPricingOfImportedFile.push({
						id: item.id,
						itemNumber: item.itemNumber,
						agreementNumber: itemToUpdate.agreementNumber,
						availabilityData: item.availabilityData ? [item.availabilityData] : [],
						pricingData: {
							items: item.pricingData ? [item.pricingData] : []
						}
					});
				});

				this.props.saveAvailabilityPricingOfImportedFile(availabilityPricingOfImportedFile);

				items.splice(
					itemIndex,
					1,
					...itemDetails.map(item => {
						const { pimData, availabilityData, orderabilityData, pricingData, ...rest } = item;

						return {
							...itemToUpdate,
							...rest,
							itemDetails: { orderabilityData, pimData },
							itemDescription: item.pimData && item.pimData.item_description,
							isNewItem: true,
							requestedQuantityError: false,
							agreementNumberError: false
						};
					})
				);
				if (this.state.shipSet === '1') {
					this.setState({
						isManualAvailabilityCheckRequired: true
					});
				}
			} else {
				itemToUpdate.itemDetails = null;
			}
		} else {
			delete itemToUpdate.isNewItem;
			delete itemToUpdate.isAddressChanged;
			delete itemToUpdate.isUnsourced;
			itemToUpdate.itemDetails = itemToUpdate.itemDetails ? { ...itemToUpdate.itemDetails, ...itemDetails } : itemDetails;
			if (
				itemDetails.availabilityData &&
				itemDetails.availabilityData &&
				(itemDetails.availabilityData.errorCode === 80 || !itemDetails.availabilityData.sourceOrganizationID)
			) {
				itemToUpdate.isUnsourced = true;
			}
			if (!itemToUpdate.requestedQuantity) {
				itemToUpdate.requestedQuantity = 1;
			}
		}

		this.setState({
			items
		});
	};

	handleDialog = (dialog, flag, event) => {
		event && event.preventDefault();

		this.setState(
			{
				['show' + dialog]: false
			},
			() => {
				this.setState({
					['show' + dialog]: flag
				});
			}
		);
	};

	handleFileImport = event => {
		this.handleDialog('ImportFileConfirmOverlayDialog', false, event);
		document.getElementById('file-input').click();
	};

	handleFileUpload = event => {
		event.preventDefault();
		const files = event.target.files;

		if (files.length > 0) {
			this.setState({
				fileUploadStatus: 'IN_PROGRESS'
			});

			const file = files[0],
				reader = new FileReader();

			reader.addEventListener('loadend', () => {
				const { userDetails } = this.props.state.user;

				fetch(s3BucketAPIBaseURL, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `${userDetails.jwt}${userDetails.sso}`
					},
					body: JSON.stringify({
						name: 'CustomerNet/tmp/' + file.name,
						type: file.type
					})
				})
					.then(response => {
						return response.json();
					})
					.then(json => {
						const list = [];

						list.push({
							fileName: file.name,
							fileURL: json.uploadURL
						});

						this.setState({
							fileName: file.name
						});

						return fetch(json.uploadURL, {
							method: 'PUT',
							body: new Blob([reader.result], {
								type: file.type
							})
						});
					})
					.then(() => {
						this.setState(
							{
								fileUploadStatus: 'SUCCESS'
							},
							() => {
								this.fileUploadInput.value = null;
								this.fetchFileContent();
							}
						);
					});
			});
			reader.readAsArrayBuffer(file);
		}
	};

	loadFinalItems = data => {
		const finalItems = [];
		const availabilityPricingOfImportedFile = [];
		let isIneligibleForSingleShipment = false;

		data.items.forEach(item => {
			const { availabilityData, orderabilityData, pricingData, pimData, ...rest } = item;
			rest.itemDescription = pimData && pimData.item_description;
			finalItems.push({ ...rest, itemDetails: { orderabilityData, pimData } });

			const availabilityPricing = {
				id: rest.id,
				itemNumber: rest.itemNumber,
				agreementNumber: rest.agreementNumber
			};

			if (availabilityData) {
				availabilityPricing.availabilityData = [availabilityData];
				if (
					this.state.shipSet === '1' &&
					!isIneligibleForSingleShipment &&
					(!availabilityData || availabilityData.availableQuantity === null || availabilityData.sourceOrganizationID === null)
				) {
					isIneligibleForSingleShipment = true;
				}
			}

			if (pricingData && pricingData.records && pricingData.records.length) {
				availabilityPricing.pricingData = {
					items: [pricingData]
				};
			}

			if (availabilityPricing.availabilityData || availabilityPricing.pricingData) {
				availabilityPricingOfImportedFile.push(availabilityPricing);
			}
		});

		this.props.saveAvailabilityPricingOfImportedFile(availabilityPricingOfImportedFile);

		let isManualAvailabilityCheckRequired;
		if (this.state.shipSet === '1' && data.isItemLimitExceededForSingleShipSet) {
			isManualAvailabilityCheckRequired = true;
			this.handleDialog('SingleShipmentLimitDialog', true);
		}

		this.setState({
			items: finalItems,
			isManualAvailabilityCheckRequired,
			isIneligibleForSingleShipment
		});
	};

	fetchFileContent = () => {
		const { selectedPriceSource } = this.props.state.user;
		const agreementNumber = selectedPriceSource ? selectedPriceSource.AGREEMENT_NUMBER : '';

		//get items from the file which was uploaded to s3
		this.props.getProductsFromS3(`requestType=getProductsFromS3&s3FileName=${encodeURIComponent(this.state.fileName)}`, productsResponse => {
			if (productsResponse.status && productsResponse.responseObject) {
				if (productsResponse.responseObject.length) {
					const itemData = { items: [], shipSet: this.state.shipSet };

					//existing items on the page
					this.state.items.forEach(item => {
						if (item.itemNumber) {
							itemData.items.push({ ...item, id: uuidv4(), isNewItem: true });
						}
					});

					productsResponse.responseObject.forEach(product => {
						let customerReference = (product.poNumber || '').toUpperCase().trim();
						customerReference = customerReference ? (isNaN(customerReference) ? customerReference : (+customerReference).toString()) : customerReference;

						itemData.items.push({
							id: uuidv4(),
							itemNumber: product.sku.trim().toUpperCase(),
							requestedQuantity: Math.max(product.orderQty, 1),
							agreementNumber,
							customerReference,
							isNewItem: true
						});
					});

					this.props.getItemDetails(
						itemData,
						data => {
							if (this.state.shipSet !== '1') {
								this.loadFinalItems(data);
							} else {
								const validItemData = {
									items: data.items,
									shipSet: this.state.shipSet,
									filterFn: item =>
										!item.isInvalid &&
										!item.isNLA &&
										!item.isRestricted &&
										!item.isPOKInstall &&
										item.pricingData &&
										item.pricingData.records &&
										item.pricingData.records.length
								};

								this.props.getItemDetails(
									validItemData,
									data => {
										this.loadFinalItems(data);
									},
									{
										searchContext: 'PNET',
										include: {
											availability: true
										},
										showLoader: true
									}
								);
							}
						},
						{
							searchContext: 'PNET',
							include: {
								pim: true,
								orderability: true,
								availability: this.state.shipSet !== '1',
								pricing: true
							},
							showLoader: true
						}
					);
				}
			} else {
				browserHistory.push('/error');
			}
		});
	};

	refreshAvailability = ({ isItemOrderabilityRequired } = {}) => {
		const items = JSON.parse(JSON.stringify(this.state.items));
		const validItems = [];

		items.forEach(item => {
			if (
				!item.isInvalid &&
				!item.isNLA &&
				// !item.isUnsourced &&
				item.itemDetails &&
				item.itemDetails.pricingData &&
				item.itemDetails.pricingData.records &&
				item.itemDetails.pricingData.records.length &&
				!item.isPOKInstall &&
				(isItemOrderabilityRequired || !item.isRestricted)
			) {
				validItems.push({
					id: item.id,
					itemNumber: item.itemNumber,
					requestedQuantity: item.requestedQuantity,
					requestedShipDate: this.state.requestedShipDate
				});

				item.isAddressChanged = true;
			}
		});

		if (validItems.length) {
			if (this.state.shipSet === '1' && validItems.length > PNET_GOP_BATCH_SIZE) {
				this.setState({
					isManualAvailabilityCheckRequired: true
				});
				this.handleDialog('SingleShipmentLimitDialog', true);
				return;
			}

			this.props.getItemDetails(
				{
					items: validItems,
					shipSet: this.state.shipSet
				},
				data => {
					const availabilityOnChangeAddress = [];
					let availabilityIssue = false;

					items.forEach(item => {
						if (item.isAddressChanged) {
							const foundItem = data.items.find(updatedItem => updatedItem.id === item.id && updatedItem.itemNumber === item.itemNumber);
							availabilityOnChangeAddress.push({
								id: item.id,
								sku: foundItem.itemNumber,
								availabilityData: foundItem.availabilityData ? [foundItem.availabilityData] : []
							});
							item.isRestricted = foundItem.isRestricted;
							item.restrictionReason = foundItem.restrictionReason;
							if (isItemOrderabilityRequired) {
								item.itemDetails.orderabilityData = foundItem.orderabilityData;
							}

							if (!availabilityIssue && (!foundItem.availabilityData || foundItem.availabilityData.sourceOrganizationID === null)) {
								availabilityIssue = true;
							}
						}
					});

					this.props.saveAvailabilityOnChangeAddress(availabilityOnChangeAddress);
					// check if availability invalid for single shipset
					this.setState({
						items,
						isIneligibleForSingleShipment: this.state.shipSet === '1' && availabilityIssue,
						isManualAvailabilityCheckRequired: false
					});
				},
				{
					searchContext: 'PNET',
					include: {
						availability: true,
						orderability: isItemOrderabilityRequired
					},
					showLoader: true
				}
			);
		}
	};

	handleMoreLines = () => {
		const agreementNumber =
			this.props.state.user.selectedPriceSource && this.props.state.user.selectedPriceSource.AGREEMENT_NUMBER
				? this.props.state.user.selectedPriceSource.AGREEMENT_NUMBER
				: '';
		const items = Array.from({ length: 10 }, () => ({
			id: uuidv4(),
			itemNumber: '',
			requestedQuantity: '',
			itemDetails: null,
			agreementNumber,
			requestedQuantityError: false,
			agreementNumberError: false,
			customerReference: '',
			customerReferenceError: false
		}));

		this.setState({
			items: [...this.state.items, ...items]
		});
	};

	handleLineDeletion = (itemIndex, event) => {
		event.preventDefault();
		let isManualAvailabilityCheckRequired = this.state.isManualAvailabilityCheckRequired;
		let removedItem;

		const newState = {
			items: this.state.items.filter((item, index) => {
				if (
					!isManualAvailabilityCheckRequired &&
					this.state.shipSet === '1' &&
					index !== itemIndex &&
					!item.isInvalid &&
					!item.isNLA &&
					!item.isRestricted &&
					item.itemDetails &&
					item.itemDetails.pricingData &&
					item.itemDetails.pricingData.records &&
					item.itemDetails.pricingData.records.length &&
					!item.isPOKInstall
				) {
					isManualAvailabilityCheckRequired = true;
				}

				if (index === itemIndex) {
					removedItem = item;
				}
				return index !== itemIndex;
			})
		};

		if (removedItem.itemDetails && removedItem.itemDetails.availabilityData && removedItem.itemDetails.availabilityData) {
			newState.isManualAvailabilityCheckRequired = isManualAvailabilityCheckRequired;
		}

		this.setState(newState);

		this.setChangeMethod = this.setChangeMethod.filter((_method, index) => index !== itemIndex);
	};

	handleRemoveAll = event => {
		event.preventDefault();
		const { selectedPriceSource } = this.props.state.user;
		let agreementNumber = '';
		if (selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
			agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
		}
		this.setState(
			{
				items: [],
				isAvailabilityCallCompleted: false,
				isPricingCallCompleted: false,
				isPimCallCompleted: false
			},
			() => {
				this.setChangeMethod = [];
				this.setState({
					items: getInitialItems(agreementNumber),
					isManualAvailabilityCheckRequired: false,
					isIneligibleForSingleShipment: false
				});
			}
		);
	};

	handleItemNumberChange = (itemIndex, itemNumber) => {
		this.setState({
			items: this.state.items.map((item, index) => {
				if (index === itemIndex) {
					const updatedItem = { ...item, itemNumber: itemNumber.toUpperCase() };

					if (![item.itemNumber, item.originalItemNumber].includes(itemNumber.toUpperCase())) {
						updatedItem.itemDetails = null;
						updatedItem.originalItemNumber = null;
						updatedItem.itemDescription = '';
						delete updatedItem.isNLA;
						delete updatedItem.isRestricted;
						delete updatedItem.isInvalidSupersedure;
						delete updatedItem.isVolumeDiscountEligible;
						delete updatedItem.isInvalid;
						delete updatedItem.isUnsourced;
					}
					return updatedItem;
				}
				return item;
			})
		});
	};

	handleRequestedQuantityChange = (itemIndex, value) => {
		let modifiedItem;

		this.setState(
			{
				items: this.state.items.map((item, index) => {
					return index === itemIndex ? (modifiedItem = { ...item, requestedQuantity: value, requestedQuantityError: value <= 0 }) : item;
				})
			},
			() => {
				if (!this.state.shipSet && modifiedItem.itemNumber && !modifiedItem.isInvalid && !modifiedItem.isNLA && !modifiedItem.isRestricted && !modifiedItem.isUnsourced) {
					const { method, input } = this.setChangeMethod[itemIndex];

					method({
						target: {
							value: input.value
						},
						onChangeOfQuantity: true
					});
				}

				if (this.state.shipSet === '1' && !this.state.isManualAvailabilityCheckRequired) {
					this.setState({
						isManualAvailabilityCheckRequired: true
					});
				}
			}
		);
	};

	handleSalesAgreementChange = (itemIndex, event) => {
		const items = JSON.parse(JSON.stringify(this.state.items));
		const agreementNumber = event.target.value;

		items[itemIndex].agreementNumber = agreementNumber;
		items[itemIndex].agreementNumberError = false;

		this.setState({
			items
		});

		const { method, input } = this.setChangeMethod[itemIndex];
		method({
			target: {
				value: input.value
			},
			onChangeOfSalesAgreement: true
		});
	};

	handleCustomerReferenceChange = (itemIndex, value) => {
		const items = JSON.parse(JSON.stringify(this.state.items));

		items[itemIndex].customerReference = value;
		items[itemIndex].customerReferenceError = false;

		this.setState({
			items
		});
	};

	handleCreateOrder = () => {
		const items = JSON.parse(JSON.stringify(this.state.itemsPayloadForCreateOrder)).filter(item => item.itemNumber);

		this.props.getItemDetails(
			{
				items: items.map(item => ({
					id: item.id,
					itemNumber: item.itemNumber,
					itemDescription: item.itemDescription,
					originalItemNumber: item.originalItemNumber,
					requestedQuantity: item.requestedQuantity,
					agreementNumber: item.agreementNumber,
					requestedShipDate: this.state.requestedShipDate,
					customerReference: item.customerReference
				})),
				shipSet: this.state.shipSet
			},
			data => {
				const pimDataForCartStore = {
					pimData: []
				};
				const pricingDataForCartStore = {
					responseObject: {
						items: []
					}
				};
				data.items.forEach(item => {
					pimDataForCartStore.pimData.push(item.pimData);
					pricingDataForCartStore.responseObject.items.push(item.pricingData);
				});
				this.props.updateCartOrderPoints(pimDataForCartStore);
				this.props.savePricesToCart(pricingDataForCartStore);

				const finalItems = [];
				const {
					user: {
						selectedPriceSource: { 'Sub Account Classification': subAccountClassification },
						selectedAddress: selectedAddressString,
						selectedAccount
					},
					order
				} = this.props.state;
				const accountNumber = selectedAccount.ACCOUNTNUMBER;
				const selectedAddress = JSON.parse(selectedAddressString || '{}');
				const zipCode = selectedAddress.COUNTRY === 'US' ? selectedAddress.POSTALCODE && selectedAddress.POSTALCODE.split('-')[0] : INTERNATIONAL_ZIP_CODE;
				// const soldToAddress = this.props.getAddressByCategory('SOLD_TO');
				// const soldToSiteNumber = soldToAddress && soldToAddress.SITENUMBER;
				const billToAddress = this.props.getAddressByCategory('BILL_TO');
				// const billToSiteNumber = billToAddress && billToAddress.SITENUMBER;

				let shipToSiteNumber = selectedAddress.SITENUMBER;
				let shipToAccountNumber = selectedAddress.SHIP_TO_ACCOUNT_NUMBER || accountNumber;
				if (!shipToSiteNumber) {
					const shipToAddress = this.props.getAddressByCategory('SHIP_TO');

					shipToSiteNumber = shipToAddress && shipToAddress.SITENUMBER;
					if (shipToAddress.SHIP_TO_ACCOUNT_NUMBER) {
						shipToAccountNumber = shipToAddress.SHIP_TO_ACCOUNT_NUMBER;
					}
				}

				const agreementNumber = this.props.state.user.selectedPriceSource.AGREEMENT_NUMBER;
				//for now it's one request and one sales agreement for all items in an order

				const shipMethodDetails = shippingMethods[this.props.isInternationalPartsCustomer ? 'international' : 'domestic'][this.state.orderType === 'R' ? 'regular' : 'emergency'].find(
							shippingMethodItem => shippingMethodItem.displayName === this.state.shippingMethod
						);

				const pricingPayload = {
					priceRequest: {
						priceRequestType: 'PARTS ONLY',
						headerPricingDate:  moment().format('DD-MMM-YYYY'),
						customerPartyAccountNumber: accountNumber,
						orderLevelModInd: 'Y',
						shipToState: selectedAddress.STATE,
						orderType: 'Standard Sales',
						orderReference: this.props.isInternationalPartsCustomer ? 'INTERNATIONAL ORDER' : 'CUSTOMER ORDER',
						shipToZipcode: zipCode,
						custClass: subAccountClassification.slice(-3),
						requestedDeliveryDate: this.state.requestedShipDate.format('DD-MMM-YYYY'),
						source: 'PartsNet',
						serviceLevel: shipMethodDetails.displayName,
						shipmentCompCode: `${this.state.orderType}${this.state.shipSet === '1' ? 'T' : 'Z'}-${
										shipMethodDetails.code
									}`,
						shipmentOrderType: this.state.orderType,
						headerShipmentMethod: shipMethodDetails.ebsShipMethodName,
						shipmentPriorityCode: `${this.state.orderType}${this.state.shipSet === '1' ? 'T' : 'Z'}`,
						billToPartySite: billToAddress && billToAddress.SITE_USE_ID,
						shipToPartySite: selectedAddress.SITE_USE_ID,
						lineItems: []
					}
				};


				let orderSubtotal = 0;

				data.items.forEach(item => {
					if (
						item.pimData &&
						(!this.props.isPOKEnabled ||
							item.pimData.geego_pok_install !== 'Y' ||
							(item.requestedQuantity && item.requestedQuantity % item.pimData.geego_pok_ord_qty === 0)) &&
						item.availabilityData &&
						item.availabilityData.sourceOrganizationID &&
						item.availabilityData.sourceOrganizationCode &&
						![80].includes(item.availabilityData.errorCode) &&
						item.pricingData &&
						item.pricingData.records &&
						item.pricingData.records.length &&
						item.pricingData.records[0].unitPrice
					) {
						orderSubtotal += item.requestedQuantity * item.pricingData.records[0].unitPrice;
						let isVolumeDiscountEligible = false;
						if (item.pimData && item.pimData.geego_discount_ind === 'Y') {
							if (item.pricingData.records.some(pricingRecord => MODIFIERS_EXCLUDED_FROM_VOLUME_DISCOUNT.includes(pricingRecord.modifierPriceSubtype))) {
								isVolumeDiscountEligible = false;
							} else {
								isVolumeDiscountEligible = true;
							}
						}
						item.isVolumeDiscountEligible = isVolumeDiscountEligible;

						finalItems.push(item);
						pricingPayload.priceRequest.lineItems.push({
							lineNo: pricingPayload.priceRequest.lineItems.length + 1,
							lineType: 'PART',
							item: item.itemNumber,
							qty: item.requestedQuantity,
							linePricingDate: null,
							salesAgreementNumber: agreementNumber.toString(),
							shipmentMethod: null,
							warehouseOrgCode: item.availabilityData.sourceOrganizationCode.split(':').at(-1),
							unCratedInd: null,
							grossPointValue: null,
							netItemIndicator: item.isVolumeDiscountEligible ? 'N' : 'Y',
						});
					}
				});

				pricingPayload.priceRequest.orderTotal = orderSubtotal;

				// make pricing service call
				this.props.getOnlinePricingForParts(pricingPayload, `requestType=priceOrder&${PNET_APP_QUERY_PARAM}`, onlinePricingResponse => {
					if (onlinePricingResponse.status && onlinePricingResponse.responseObject) {
						const orderInfo = {
							orderType: this.state.orderType,
							requestedShipDate: this.state.requestedShipDate.format('YYYY-MM-DD'),
							shippingMethod: this.state.shippingMethod,
							shipSet: this.state.shipSet,
							freightForwarder:
								this.state.freightForwarder && order.createOrderPayload && order.createOrderPayload.availableFreightForwarders
									? order.createOrderPayload.availableFreightForwarders.find(
											availableFreightForwarder =>
												availableFreightForwarder.SITE_USE_ID && availableFreightForwarder.SITE_USE_ID.toString() === this.state.freightForwarder
									  )
									: null
						};

						const itemsForCheckout = [];
						finalItems.forEach((item, index) => {
							const onlinePricingData =
								onlinePricingResponse.responseObject &&
								onlinePricingResponse.responseObject.priceResponse &&
									onlinePricingResponse.responseObject.priceResponse.find(
										pricingItem => pricingItem.item === item.itemNumber && pricingItem.lineIndex.toString() === (index + 1).toString()
									);

							if (onlinePricingData) {
									const bagItems = [];
									(onlinePricingData.discounts || []).forEach(discount => {
										if (discount.bagItem && !bagItems.some(existing => existing.name === discount.bagItem)) {
											const bagItemLine = onlinePricingResponse.responseObject.priceResponse.find(
												line => line.item === null && (line.discounts || []).some(d => d.itemName === discount.bagItem)
											);
											const bagItemQty = discount.parentLineQty || (bagItemLine ? bagItemLine.qty : 1);
											const bagItemPrice = bagItemLine ? bagItemLine.salesPrice : 0;

											bagItems.push({
												name: discount.bagItem,
												priceSubType: discount.priceSubType,
												price: bagItemPrice,
												quantity: bagItemQty,
												extendedPrice: bagItemPrice * bagItemQty 
											});
										}
									});
								const newItem = {
									id: item.id,
									itemNumber: item.itemNumber.trim(),
									originalItemNumber: item.originalItemNumber,
									itemDescription: item.itemDescription,
									primaryUnitOfMeasure: item.pimData.primary_unit_of_measure,
									itemType: item.itemType,
									quantity: item.requestedQuantity,
									quantityError: '',
									availableQuantity: item.availabilityData.availableQuantity,
									warehouseCode: item.availabilityData.sourceOrganizationCode.split(':').at(-1),
									sourceOrganizationId: item.availabilityData.sourceOrganizationID,
									eta: item.availabilityData.arrivalDate,
									unitPrice: item.pricingData.records[0].unitPrice,
									adjustedUnitPrice: onlinePricingData.salesPrice,
									extendedPrice: onlinePricingData.extendedPrice,
									isVolumeDiscountEligible: item.isVolumeDiscountEligible,
									agreementNumber: item.agreementNumber,
									customerReference: item.customerReference,
									redirectFrom: 'quickorder',
									bagItems
								};

								itemsForCheckout.push(newItem);
							}
						});

						this.props.saveCreateOrderPayload({
							...(order.createOrderPayload || {}),
							...orderInfo,
							items: itemsForCheckout,
							handlingCharge: onlinePricingResponse.responseObject.deliveryHandlingCharges,
							shipToSiteUseId: selectedAddress.SITE_USE_ID
						});

						if (itemsForCheckout.length) {
							browserHistory.push('/order/createOrder');
						}
					}
				});
			},
			{
				searchContext: 'PNET',
				include: {
					pim: true,
					availability: true,
					pricing: true
				},
				showLoader: true,
				parallelCalls: true,
				skipPOKCheck: true
			}
		);
	};

	handleAddToCart = items => {
		const {
			user: { selectedAccount, userDetails },
			order
		} = this.props.state;
		let freightForwarder =
			this.state.freightForwarder &&
			order.createOrderPayload &&
			order.createOrderPayload.availableFreightForwarders &&
			order.createOrderPayload.availableFreightForwarders.find(
				availableFreightForwarder => availableFreightForwarder.SITE_USE_ID && availableFreightForwarder.SITE_USE_ID.toString() === this.state.freightForwarder
			);
		freightForwarder = freightForwarder && `${freightForwarder.SITE_USE_ID}|${freightForwarder.NAME}`;

		let payload = {
			accountNumber: selectedAccount.ACCOUNTNUMBER,
			createdDate: moment().format('MM/DD/YYYY'),
			updatedDate: moment().format('MM/DD/YYYY'),
			userId: userDetails.sso,
			orderType: this.state.orderType,
			requestedShipDate: this.state.requestedShipDate.format('MM/DD/YYYY'),
			shipMethod: this.state.shippingMethod,
			shipSet: this.state.shipSet,
			freightForwarder: freightForwarder || undefined,
			cartItems: items
		};

		this.props.addToPartsCart(payload, response => {
			if (response.status && response.responseObject) {
				this.props.saveToCart(response);
				this.setState(
					{
						isAvailabilityCallCompleted: false,
						availabilityData: []
					},
					() => {
						this.handleCreateOrder();
					}
				);
			} else {
				browserHistory.push('/error');
			}
		});
	};

	continueToCreateOrder = () => {
		const { updatedItemsForCart, itemsPayloadForCreateOrder } = this.state;
		const items = this.state.pokItems.concat(this.state.items); // combine both pok and quickorder items

		items.forEach(item => {
			if (!item.isAlreadyAdded && item.itemNumber && !item.isNLA) {
				updatedItemsForCart.push({
					id: item.id,
					item: item.itemNumber,
					quantity: item.requestedQuantity,
					itemDescription: item.itemDescription,
					agreementNumber: item.agreementNumber,
					createdDate: moment().format(DATE_TIME_FORMAT),
					updatedDate: moment().format(DATE_TIME_FORMAT),
					poNumber: item.customerReference,
					parentItem: item.originalItemNumber,
					buyerLineNo: item.id
				});
				itemsPayloadForCreateOrder.push(JSON.parse(JSON.stringify(item)));
			}
		});

		this.setState(
			{
				itemsPayloadForCreateOrder
			},
			() => {
				this.handleAddToCart(updatedItemsForCart);
			}
		);
	};

	appendCartItems = () => {
		const {
			selectedAccount: { ACCOUNTNUMBER: accountNumber }
		} = this.props.state.user;
		const cartItems = JSON.parse(JSON.stringify(this.props.state.cart.cart.responseObject.cartItems));
		const items = JSON.parse(JSON.stringify(this.state.items));
		const pokItems = JSON.parse(JSON.stringify(this.state.pokItems));
		const updatedItemsForCart = [];
		const itemsPayloadForCreateOrder = [];

		//check cart items orderability
		this.props.checkItemOrderabilityInBatches(
			cartItems.map(cartItem => `'${cartItem.item}'`),
			`&accountNumber=${accountNumber}&${this.getAddressParamsForOrderability()}&orgId=82&${PNET_APP_QUERY_PARAM}`,
			null,
			true,
			orderabilityResponse => {
				if (orderabilityResponse) {
					cartItems.forEach(cartItem => {
						const cartItemOrderabilityData = orderabilityResponse.find(orderabilityItem => orderabilityItem.INVENTORY_ITEM === cartItem.item);

						if (cartItemOrderabilityData && cartItemOrderabilityData.ITEM_ORDERABILITY_FLAG === 'Y') {
							updatedItemsForCart.push(cartItem);

							const itemOverriddenBy = pokItems.find(pokItem => {
								if (pokItem.itemNumber.toLowerCase() === cartItem.item.toLowerCase()) {
									pokItem.isAlreadyAdded = true;
									return true;
								}
								return false;
							});

							if (itemOverriddenBy) {
								cartItem.agreementNumber = itemOverriddenBy.agreementNumber;
								cartItem.quantity = itemOverriddenBy.requestedQuantity;
								cartItem.poNumber = itemOverriddenBy.customerReference;
							}

							itemsPayloadForCreateOrder.push({
								id: cartItem.buyerLineNo,
								packageName: cartItem.packageName ? cartItem.packageName.toUpperCase() : '',
								itemNumber: cartItem.item,
								originalItemNumber: cartItem.parentItem,
								itemDescription: cartItem.itemDescription,
								requestedQuantity: cartItem.quantity,
								requestedQuantityError: false,
								agreementNumber: !isNaN(cartItem.agreementNumber) ? +cartItem.agreementNumber : cartItem.agreementNumber,
								agreementNumberError: false,
								customerReference: cartItem.poNumber || ''
							});
						}
					});

					this.setState(
						{
							items,
							pokItems,
							updatedItemsForCart,
							itemsPayloadForCreateOrder
						},
						() => {
							this.continueToCreateOrder();
						}
					);
				}
			}
		);
	};

	handleCartItems = action => {
		const updatedItemsForCart = [];
		const itemsPayloadForCreateOrder = [];

		if (action === 'combine') {
			this.appendCartItems();
		} else if (action === 'delete') {
			this.setState(
				{
					updatedItemsForCart,
					itemsPayloadForCreateOrder
				},
				() => {
					this.continueToCreateOrder();
				}
			);
		}
	};

	onSalesAgreementAndShipToAddressConfirmation = () => {
		this.handleDialog('SalesAgreementAndShipToAddressConfirmationDialog', false);

		const cartItems = this.props.state.cart && this.props.state.cart.cart && this.props.state.cart.cart.responseObject && this.props.state.cart.cart.responseObject.cartItems;
		// if single shipset, override existing cart
		if (this.state.shipSet === '1' || !cartItems || cartItems.length === 0) {
			this.handleCartItems('delete');
		}
		// popup if cart is not empty
		else {
			this.handleDialog('ProductsInTheCartOverlayDialog', true);
		}
	};

	verifyCartItems = () => {
		const { order } = this.props.state;
		const pokData = this.installFormRef.current && this.installFormRef.current.getItems();

		if (
			this.state.showFreightForwarder === 'Y' &&
			order.createOrderPayload &&
			order.createOrderPayload.availableFreightForwarders &&
			order.createOrderPayload.availableFreightForwarders.length &&
			!this.state.freightForwarder
		) {
			this.setState(
				{
					isFreightForwarderError: true
				},
				() => {
					scrollTo && scrollTo({ top: 0, behavior: 'auto' });
				}
			);
			return;
		}

		if ((this.props.isPOKEnabled && pokData && pokData.isQuantityError) || (this.state.shipSet === '1' && this.state.isManualAvailabilityCheckRequired)) {
			return;
		}

		const {
			selectedPriceSource: { AGREEMENT_NUMBER: agreementNumber }
		} = this.props.state.user;
		let emptyRowsCount = 0;

		let isError = this.state.items.some(item => {
			if (item.itemNumber.trim()) {
				if (item.itemDetails) {
					const itemAvailabilityData = item.itemDetails.availabilityData && item.itemDetails.availabilityData;
					let itemPricingData =
						item.itemDetails.pricingData &&
						item.itemDetails.pricingData &&
						item.itemDetails.pricingData.records &&
						item.itemDetails.pricingData.records[0] &&
						item.itemDetails.pricingData.records[0].unitPrice;
					// const itemPimData = pimData && _.find(pimData, { item_number: item.item });
					// const isPOKInstall = isPOKEnabled && itemPimData && itemPimData.geego_pok_install === 'Y';
					// const pokOrderQuantity = itemPimData && itemPimData.geego_pok_ord_qty;

					//errorCode 19 - One of the group elements or mandatory components failed
					//errorCode 52 - Unable to meet the request quantity
					//errorCode 53 - Cannot meet request date or latest acceptable date
					//errorCode 80 - No Sources
					if (
						item.isInvalid ||
						item.isNLA ||
						item.isRestricted ||
						item.isUnsourced ||
						!item.requestedQuantity ||
						item.requestedQuantity <= 0 ||
						item.agreementNumber !== agreementNumber ||
						!itemAvailabilityData ||
						[80, 52].includes(itemAvailabilityData.errorCode) ||
						!itemPricingData ||
						// !itemPimData ||
						// itemPimData.item_status === 'Inactive' ||
						item.isPOKInstall
					) {
						// console.log('ITEM ERROR ', item, itemAvailabilityData, itemPricingData);
						return true;
					}
				} else {
					return true;
				}
			} else {
				emptyRowsCount += 1;
			}

			return false;
		});

		this.setState(
			{
				errorMessage: '',
				isAvailabilityCallCompleted: false,
				isBillingReferencesCallCompleted: false,
				isPimCallCompleted: false,
				isPricingCallCompleted: false,
				pokItems: pokData ? pokData.items : []
			},
			() => {
				if (isError) {
					this.handleDialog('InvalidItemsDialog', true);
					return;
				} else if (!pokData || !pokData.items.length) {
					if (emptyRowsCount === this.state.items.length) {
						this.handleDialog('NoItemsDialog', true);
						return;
					}
				}
				this.props.checkIfAnyActiveSoldAddress(() => {
					this.handleDialog('SalesAgreementAndShipToAddressConfirmationDialog', true);
				});
			}
		);
	};

	render() {
		const hasPricingAccess = this.props.isResponsibilityExists('Price');
		const hasCreateOrderAccess = this.props.isResponsibilityExists('Create New Order');
		const { order } = this.props.state;

		const importFileElement = (
			<div className="text-right">
				<a
					href=""
					className="greenBtn w-max flex items-center"
					onClick={event => this.handleDialog('ImportFileConfirmOverlayDialog', true, event)}
					style={{ fontSize: 'inherit' }}
				>
					Import File
					{this.state.fileUploadStatus === 'IN_PROGRESS' && (
						<span
							style={{
								display: 'inline-block',
								height: '1em',
								aspectRatio: '1',
								borderRadius: '50%',
								border: '3px solid #ffffff',
								borderBottomColor: 'transparent',
								animation: 'spin 1s linear infinite',
								marginLeft: '.5rem',
								boxSizing: 'border-box'
							}}
						/>
					)}
				</a>
			</div>
		);

		return (
			<section className="pNetQO">
				<div className="pNetQOHeader smallPush">
					<h1 className="pageTitle">Quick Order / Availability</h1>
					{this.props.isFreightDocumentAvailable && (
						<a href="" className="bold red" onClick={this.props.handleGetFreightDocument}>
							Link to Freight Charges & Discounts
						</a>
					)}
				</div>
				<CollapsibleSection title={hasCreateOrderAccess ? 'Order Information' : 'Additional Information'}>
					{this.props.isInternationalPartsCustomer && (
						<div className="pNetQOOrderInfoRow">
							<div>
								<label htmlFor="pNetShowFreightForwarder">
									<b>Send Order to Freight Forwarder?</b>
								</label>
								<select
									id="pNetShowFreightForwarder"
									name="showFreightForwarder"
									className="fullWidth"
									value={this.state.showFreightForwarder}
									onChange={this.handleChange}
								>
									<option value="Y">Yes</option>
									<option value="N">No</option>
								</select>
							</div>
							{this.state.showFreightForwarder === 'Y' && (
								<div className={this.state.isFreightForwarderError ? 'error' : undefined} style={{ width: 'min(100%, 25rem)', position: 'relative' }}>
									<label htmlFor="pNetFreightForwarder">
										<b>Freight Forwarder</b>
									</label>
									<select
										id="pNetFreightForwarder"
										className="fullWidth"
										name="freightForwarder"
										value={this.state.freightForwarder}
										onChange={this.handleChange}
									>
										<option value="" disabled>
											Select
										</option>
										{order.createOrderPayload &&
											order.createOrderPayload.availableFreightForwarders &&
											order.createOrderPayload.availableFreightForwarders.map(availableFreightForwarder => (
												<option key={availableFreightForwarder.SITE_USE_ID} value={availableFreightForwarder.SITE_USE_ID}>
													{[
														availableFreightForwarder.NAME,
														availableFreightForwarder.ADDRESS1,
														availableFreightForwarder.ADDRESS2,
														availableFreightForwarder.ADDRESS3,
														availableFreightForwarder.CITY,
														availableFreightForwarder.STATE,
														availableFreightForwarder.COUNTRY,
														availableFreightForwarder.POSTALCODE
													]
														.filter(addressField => addressField && addressField.trim())
														.join(', ')}
												</option>
											))}
									</select>
									{this.state.isFreightForwarderError && (
										<p className="message" style={{ position: 'absolute' }}>
											Please select a freight forwarder
										</p>
									)}
								</div>
							)}
						</div>
					)}
					<div className="pNetQOOrderInfoRow">
						<div>
							<label htmlFor="pNetOrderType">
								<b>Order Type</b>
							</label>
							<select id="pNetOrderType" className="fullWidth" name="orderType" value={this.state.orderType} onChange={this.handleChange}>
								<option value="R">Regular</option>
								<option value="E">Emergency</option>
							</select>
						</div>
						<div>
							<label htmlFor="pNetReqShipDate">
								<b>Requested Ship Date</b>
							</label>
							<DatePicker
								id="pNetReqShipDate"
								className="pNetReqShipDate"
								filterDate={() => true}
								disabled={false}
								minDate={moment()}
								placeholderText="Click to select a date"
								selected={this.state.requestedShipDate}
								onChange={this.handleRequestedShipDateChange}
								style={{ width: '25%' }}
							/>
						</div>
					</div>
					<div className="pNetQOOrderInfoRow">
						<div>
							<label htmlFor="pNetShippingMethod">
								<b>Ship Method</b>
							</label>
							<select id="pNetShippingMethod" className="fullWidth" name="shippingMethod" value={this.state.shippingMethod} onChange={this.handleChange}>
								{shippingMethods[this.props.isInternationalPartsCustomer ? 'international' : 'domestic'][
									this.state.orderType === 'R' ? 'regular' : 'emergency'
								].map(shippingMethod => (
									<option key={shippingMethod.displayName} value={shippingMethod.displayName}>
										{shippingMethod.displayName}
									</option>
								))}
							</select>
						</div>
						<div>
							<label htmlFor="pNetShipSet">
								<b>Shipment Profile / Ship Set</b>
							</label>
							<select
								id="pNetShipSet"
								className="fullWidth"
								name="shipSet"
								value={this.state.shipSet}
								onChange={this.handleChange}
								disabled={this.props.isPOKEnabled}
							>
								{!this.props.isPOKEnabled && <option value="1">Single Shipment</option>}
								<option value="">Unlimited Shipment</option>
							</select>
						</div>
					</div>
				</CollapsibleSection>
				<input
					ref={input => (this.fileUploadInput = input)}
					id="file-input"
					style={{ display: 'none' }}
					accept=".xlsx, .xls, .csv"
					onChange={this.handleFileUpload.bind(this)}
					type="file"
				/>
				{this.props.isPOKEnabled && (
					<PartsNetInstallForm
						ref={this.installFormRef}
						salesAgreements={this.state.partsNetSalesAgreements}
						formatMoney={this.props.formatMoney}
						getItemDetails={this.props.getItemDetails}
					/>
				)}
				<CollapsibleSection
					title={hasCreateOrderAccess ? 'Quick Order' : 'Price and Availability'}
					headerRight={importFileElement}
					expand={!this.props.isPOKEnabled || this.state.fileUploadStatus}
				>
					<form className="pNetQOForm">
						{this.state.shipSet === '1' && this.state.isIneligibleForSingleShipment && (
							<p className="red">
								These parts cannot be shipped from one warehouse. Please select shipment profile <strong>Unlimited</strong> to process the order from different
								warehouses.
							</p>
						)}
						<table className="pNetQOTable dataTable font12 fullWidth mt-0">
							<thead>
								<tr>
									<th className="textCenter">
										<a className="deleteAllLink" href="" onClick={this.handleRemoveAll}>
											✗
										</a>
									</th>
									<th className="textCenter" style={{ paddingInline: 0 }}>
										Item
									</th>
									<th className="textCenter">Original Item</th>
									<th className="textCenter">Item Description</th>
									<th className="textCenter">Requested Qty</th>
									<th className="textCenter">Qty Available</th>
									<th className="textCenter">Whse</th>
									<th className="textCenter">ETA</th>
									<th className="textCenter">Book Price</th>
									<th className="textCenter">Selling Price</th>
									<th className="textCenter">Volume Discount Eligible</th>
									<th className="textCenter">Sales Agreement</th>
									<th className="textCenter">Customer Reference</th>
								</tr>
							</thead>
							<tbody className="text-center">
								{this.state.items.map((item, index) => {
									const itemAvailabilityData = (item.itemDetails && item.itemDetails.availabilityData) || {};
									const isQuantityNotAvailableOnRequestedDate = itemAvailabilityData.availableQuantity >= 1410065408;
									const itemData = {
										availableQuantity: itemAvailabilityData.availableQuantity,
										warehouseCode: itemAvailabilityData.sourceOrganizationCode,
										eta: itemAvailabilityData.arrivalDate,
										availabilityMessage:
											(isQuantityNotAvailableOnRequestedDate && 'BACKORDER') ||
											(itemAvailabilityData.availableQuantity && itemAvailabilityData.availableQuantity < item.requestedQuantity && 'PARTIAL') ||
											'',
										errorCode: itemAvailabilityData.errorCode
									};
									const showItemDetails = !item.isRestricted;
									let unitPrice = '',
										adjustedUnitPrice = '';
									if (item.itemDetails && item.itemDetails.pricingData) {
										const pricingData = item.itemDetails.pricingData;

										if (pricingData && pricingData.records && pricingData.records.length) {
											if (pricingData.records[0].unitPrice) {
												unitPrice = this.props.formatMoney(pricingData.records[0].unitPrice, 0, '.', ',', false, '$');
											}
											if (pricingData.records[0].adjustedUnitPrice) {
												adjustedUnitPrice = this.props.formatMoney(pricingData.records[0].adjustedUnitPrice, 0, '.', ',', false, '$');
											}
										}
									}

									const requestedQuantityError =
										item.requestedQuantityError ||
										(item.itemDetails &&
											item.itemDetails.pricingData &&
											item.itemDetails.pricingData.length &&
											!item.isNLA &&
											!item.isRestricted &&
											!item.isInvalid &&
											!itemData.availableQuantity &&
											itemData.errorCode === 52);

									let itemErrorMessage;
									if (item.isRestricted) {
										if (item.itemDetails && item.itemDetails.orderabilityData && item.itemDetails.orderabilityData.error) {
											itemErrorMessage = 'An error has occured, please try again shortly';
										} else {
											itemErrorMessage = `Restricted${item.restrictionReason ? ` - ${item.restrictionReason}` : ''}`;
										}
									} else if (item.isNLA) {
										itemErrorMessage = 'No Longer Available';
									} else if (item.isInvalid) {
										itemErrorMessage = 'Invalid Item';
									} else if (item.isPOKInstall) {
										itemErrorMessage = 'POK Item';
									} else if (item.itemDetails && !unitPrice) {
										itemErrorMessage = 'Item not in Price List';
									} else if (item.isUnsourced) {
										if (itemData.warehouseCode && !itemData.warehouseCode.includes(':')) {
											itemErrorMessage = 'An error has occured, please try again shortly';
										} else if (!(this.state.shipSet === '1' && this.state.isIneligibleForSingleShipment)) {
											itemErrorMessage = 'This item cannot be ordered from this warehouse';
										}
									}

									return (
										<tr key={item.id}>
											<td>
												<a className="deleteLink" href="" onClick={this.handleLineDeletion.bind(this, index)}>
													✗
												</a>
											</td>
											<td className="pNetQOItemNumber" style={{ paddingInline: 0 }}>
												<AccountNumberAutoSuggests
													checkAvailabilityInBatches={this.props.checkAvailabilityInBatches}
													getShippingAddressesDetails={this.props.getShippingAddressesDetails}
													value={item.itemNumber}
													setChangeMethod={(method, input) => (this.setChangeMethod[index] = { method, input })}
													selectedPriceSource={item.agreementNumber}
													updateQuickOrderState={this.updateQuickOrderState.bind(this)}
													onChangeProductNumberTextBox={this.handleItemNumberChange.bind(this)}
													itemIndex={index}
													zipCode={this.props.customZipCode}
													itemType={item.itemType}
													isNewItem={item.isNewItem}
													isAddressChanged={item.isAddressChanged}
													width="6rem"
													whichPage="quickorder"
													getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
													itemDetails={item}
													requestedShipDate={this.state.requestedShipDate}
													shipSet={this.state.shipSet}
													quantity={item.requestedQuantity}
													searchContext="PNET"
													getItemDetails={this.props.getItemDetails}
												/>
											</td>
											<td>{item.originalItemNumber}</td>
											<td className={itemErrorMessage ? 'red' : undefined}>{itemErrorMessage || item.itemDescription}</td>
											<td className={`pNetItemReqQty${item.requestedQuantityError ? ' pNetItemReqQtyError' : ''}`}>
												<QuantityInput
													className={requestedQuantityError && 'error'}
													value={item.requestedQuantity}
													onChange={this.handleRequestedQuantityChange.bind(this, index)}
													disabled={
														item.isInvalid ||
														item.isRestricted ||
														item.isNLA ||
														item.isUnsourced ||
														item.isPOKInstall ||
														(item.itemNumber && !item.itemDetails) ||
														(item.itemDetails && !unitPrice) ||
														(this.state.shipSet === '1' && this.state.isIneligibleForSingleShipment)
													}
												/>
											</td>
											<td className={showItemDetails && isQuantityNotAvailableOnRequestedDate && !itemData.eta ? ' bold red' : ''}>
												{showItemDetails && <React.Fragment>
													{isQuantityNotAvailableOnRequestedDate ? 0 : itemData.availableQuantity}
													{itemData.availabilityMessage && (
														<strong className="block" style={{ fontSize: '.5rem', marginTop: '.25rem', color: '#7a7a7a' }}>
															{itemData.availabilityMessage}
														</strong>
													)}
												</React.Fragment>}
											</td>
											<td>{showItemDetails && itemData.warehouseCode && itemData.warehouseCode.split(':').at(-1)}</td>
											<td>{showItemDetails && isQuantityNotAvailableOnRequestedDate && itemData.eta && moment(itemData.eta).format('MM/DD/YYYY')}</td>
											<td>{showItemDetails && unitPrice}</td>
											<td>{showItemDetails && adjustedUnitPrice}</td>
											<td>{showItemDetails && item.itemDetails && item.itemDetails.pricingData && (item.isVolumeDiscountEligible ? 'Yes' : 'No')}</td>
											<td>
												<select
													className={`fullWidth${item.agreementNumberError ? ' error' : ''}`}
													value={item.agreementNumber}
													onChange={this.handleSalesAgreementChange}
												>
													{this.state.partsNetSalesAgreements.map(({ AGREEMENT_NUMBER, AGREEMENT_NAME }) => (
														<option key={AGREEMENT_NUMBER}>{AGREEMENT_NAME}</option>
													))}
												</select>
											</td>
											<td className="">
												<CustomerReferenceInput value={item.customerReference} onChange={this.handleCustomerReferenceChange.bind(this, index)} />
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
						<div className="flex justify-between">
							<button type="button" className="px-0" onClick={this.handleMoreLines} style={{ background: 'none', color: '#1a63a2', fontSize: 'inherit' }}>
								+ <u>ADD more lines</u>
							</button>
							{this.state.shipSet === '1' && (
								<button
									type="button"
									onClick={this.refreshAvailability.bind(this, { isItemOrderabilityRequired: false })}
									disabled={!this.state.isManualAvailabilityCheckRequired}
									style={{ fontSize: 'inherit' }}
								>
									CHECK AVAILABILITY
								</button>
							)}
						</div>
					</form>
				</CollapsibleSection>
				{hasCreateOrderAccess && hasPricingAccess && (
					<p className="d-flex justify-content-end my-0">
						<button type="button" onClick={this.verifyCartItems} disabled={this.state.shipSet === '1' && this.state.isManualAvailabilityCheckRequired}>
							CREATE ORDER
						</button>
					</p>
				)}
				{this.state.showImportFileConfirmOverlayDialog && (
					<ImportFileConfirmOverlayDialog handleDialog={this.handleDialog.bind(this)} handleImportAction={this.handleFileImport.bind(this)} showDialog={true} />
				)}
				{this.state.showProductsInTheCartOverlayDialog && (
					<ProductsInTheCartOverlayDialog howToHandleCartItems={this.handleCartItems.bind(this)} handleDialog={this.handleDialog} showDialog={true} />
				)}
				{this.state.showNoItemsDialog && (
					<GenericOverlayDialog
						buttons="ok"
						genericDialogHeading="No Items"
						genericDialogText="Please add atleast one valid item to create order."
						flag="NoItemsDialog"
						handleOk={this.handleDialog.bind(this, 'NoItemsDialog', false)}
						showDialog={true}
						defaultTop
					/>
				)}
				{this.state.showInvalidItemsDialog && (
					<GenericOverlayDialog
						buttons="ok"
						genericDialogHeading="Invalid Parts"
						genericDialogText="Your order has invalid parts, Please remove and resubmit."
						flag="InvalidItemsDialog"
						handleOk={this.handleDialog.bind(this, 'InvalidItemsDialog', false)}
						showDialog={true}
						defaultTop
					/>
				)}
				{this.state.showSalesAgreementAndShipToAddressConfirmationDialog && (
					<GenericOverlayDialog
						buttons="no,yes"
						genericDialogHeading="Confirm"
						genericDialogText="Please confirm Sales Agreement and Ship To Address are correct before proceeding."
						extraParagraph="Is the information correct?"
						flag="SalesAgreementAndShipToAddressConfirmationDialog"
						handleYes={this.onSalesAgreementAndShipToAddressConfirmation}
						showDialog={true}
						defaultTop
					/>
				)}
				{this.state.showSingleShipmentLimitDialog && (
					<GenericOverlayDialog
						buttons="ok"
						genericDialogHeading="Item Limit Exceeded"
						genericDialogText={`You can add at most ${PNET_GOP_BATCH_SIZE} items for Single Shipment. Please remove and check availability again.`}
						flag="SingleShipmentLimitDialog"
						handleOk={this.handleDialog.bind(this, 'SingleShipmentLimitDialog', false)}
						showDialog={true}
						defaultTop
					/>
				)}
			</section>
		);
	}
}

const mapStateToProps = state => {
	return { state };
};

const mapDispatchToProps = dispatch => ({
	getOnlinePricingForParts: (payload, params, response) => dispatch(getOnlinePricingForParts(payload, params, response)),
	updateCartOrderPoints: pimData => dispatch(updateCartOrderPoints(pimData)),
	saveCreateOrderPayload: payload => dispatch(saveCreateOrderPayload(payload)),
	saveAvailabilityOnChangeAddress: data => dispatch(saveAvailabilityOnChangeAddress(data)),
	saveToCart: data => dispatch(saveToCart(data)),
	savePricesToCart: data => dispatch(savePricesToCart(data, true)),
	saveAvailabilityPricingOfImportedFile: data => dispatch(saveAvailabilityPricingOfImportedFile(data)),
	addToPartsCart: (payload, callback) => dispatch(addToPartsCart(payload, callback)),
	getProductsFromS3: (queryString, callback) => dispatch(getProductsFromS3(queryString, callback)),
	ajaxRequestInitiated: data => dispatch(ajaxRequestInitiated(data)),
	ajaxRequestCompleted: data => dispatch(ajaxRequestCompleted(data))
});

PartsNetQuickOrderForm = connect(mapStateToProps, mapDispatchToProps)(PartsNetQuickOrderForm);

export default PartsNetQuickOrderForm;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/partsNetQuickOrderForm.js